export default [
  {
    path: 'create',
    name: 'Create',
    meta: {
      title: '发动态',
      keepAlive: true
    },
    component: () =>
      import('../views/exerland/dynamic/create.vue')
  },
  {
    path: 'ESGcreate',
    name: 'ESGcreate',
    meta: {
      title: '发动态',
      keepAlive: true
    },
    component: () =>
      import('../views/exerland/dynamic/ESGcreate.vue')
  },
  {
    path: 'dynamicTetail/:id',
    name: 'DynamicTetail',
    meta: {
      title: '详情',
      keepAlive: true
    },
    component: () =>
      import(
        '../views/exerland/dynamic/dynamicDetail.vue'
      )
  },
  {
    path: 'pushDynamicDetail/:id',
    name: 'pushDynamicDetail',
    meta: {
      title: '星圈',
      keepAlive: true
    },
    component: () =>
      import(
        '../views/exerland/dynamic/pushDynamicDetail.vue'
      )
  },
  {
    path: 'pushPoster/:id',
    name: 'pushPoster',
    meta: {
      title: '员工关怀',
      keepAlive: true
    },
    component: () =>
      import(
        '../views/exerland/dynamic/pushPoster.vue'
      )
  },
  {
    path: 'pushPrize/:id',
    name: 'pushPrize',
    meta: {
      title: '恭喜中奖',
      keepAlive: true
    },
    component: () =>
      import(
        '../views/exerland/dynamic/pushPrize.vue'
      )
  }
]
